import { Badge } from '@/components/ui/badge';
import { IMAGES } from './retreatsData';

export const MeetHostsSection = () => (
  <section id="hosts" className="py-20 px-6 bg-forest text-white" data-testid="meet-hosts-section">
    <div className="max-w-6xl mx-auto">
      <div className="text-center mb-16">
        <Badge className="bg-white/20 text-white mb-4">Your Guides</Badge>
        <h2 className="font-heading text-4xl md:text-5xl font-bold mb-4">
          Meet Crystal &amp; Dr. Nicole
        </h2>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="flex justify-center">
          <div className="rounded-2xl overflow-hidden border-4 border-terracotta shadow-2xl max-w-md">
            <img
              src={IMAGES.crystalAndNicole}
              alt="Crystal Khalil & Dr. Nicole LaBeach"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="space-y-8">
          <div>
            <h3 className="font-heading text-2xl font-bold mb-2">Crystal Khalil</h3>
            <p className="text-terracotta font-medium mb-3">The Divine Disruptor &amp; Destiny Dealer</p>
            <p className="text-white/80 leading-relaxed">
              The strategist with soul, the executive whisperer. From boardrooms to Bible study, she moves with purpose
              and power. With 30+ years of corporate savvy and a heart for service, she&apos;s built a movement through
              Sister Diamonds and Volition Enterprises.
            </p>
          </div>

          <div className="border-t border-white/20 pt-8">
            <h3 className="font-heading text-2xl font-bold mb-2">Dr. Nicole LaBeach</h3>
            <p className="text-terracotta font-medium mb-3">The Soul Surgeon &amp; Sacred Strategist</p>
            <p className="text-white/80 leading-relaxed">
              With a Ph.D. in psychology and 25+ years of experience, Dr. Nicole transforms lives. Featured on GMA, CBS
              Radio, Oprah Daily, Essence, and as the 3-season host of &quot;Put A Ring On It&quot; on OWN. She holds
              space for you to remember who you were before the world told you who to be.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
